import {ArticleSection} from './ArticleSection';
export default ArticleSection;
